import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class BinaBildirimListeAPI extends BaseAPI {
  constructor() {
    const baseUrl =
    environment.API_URL + "BinaBildirimListe";
    super(baseUrl);
  }

  getBinaBildirimListeListe(pafta: string,tapuBagimsizBolumNo: string ,kapiNo: string, ada?:number,parsel?:number, mahalleKodu?: number, caddeSokakKodu?: number) {
    var request = new BinaBildirimListeRequest(pafta,tapuBagimsizBolumNo,kapiNo,ada,parsel, mahalleKodu, caddeSokakKodu);
    return this.post("", request, false);
  }
}
export default new BinaBildirimListeAPI();
class BinaBildirimListeRequest {
  public pafta: string;
  public ada?: number;
  public parsel?: number;
  public tapuBagimsizBolumNo: string;
  public mahalleKodu?: number;
  public caddeSokakKodu?: number;
  public kapiNo: string;
  constructor(pafta: string,tapuBagimsizBolumNo:string , kapiNo: string,ada?:number,parsel?:number,  mahalleKodu?: number, caddeSokakKodu?: number) {

    this.pafta = pafta;
    this.ada = ada;
    this.parsel = parsel;
    this.tapuBagimsizBolumNo = tapuBagimsizBolumNo;
    this.mahalleKodu = mahalleKodu;
    this.caddeSokakKodu = caddeSokakKodu;
    this.kapiNo = kapiNo;
  }
}
export { BinaBildirimListeRequest };
